import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IBankInstallmentsRequest {
  cardNumber: string;
  merchantId: number;
  amount: string;
  currency: string;
}

async function getBankInstallments(data: IBankInstallmentsRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/Payment/Installment", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetBankInstallments() {
  return useMutation<any, Error, IBankInstallmentsRequest>((variables) =>
    getBankInstallments(variables)
  );
}
